module.exports = __webpack_public_path__ + "static/media/edit-recurring.966de181.png";